const importantNotes = [
  {
    type: "note",
    category: [`precon`],
    text: `New Builds typically pay commission calculated on the sale price net of
    HST.`,
  },
  {
    type: "note",
    category: [`precon`],
    text: `Please note that for commissions paid in installments, there will be
    multiple files/sub-trades created by the staff once you upload all your 
    documents into SkySlope. The complete set of documents are found in the file 
    labeled “A”.`,
  },
  {
    type: "note",
    category: [`mls`],
    text: `If the listing is on multiple boards, please provide the MLS Data Forms 
    for each board.`,
  },
  {
    type: "note",
    category: [`mls`],
    text: `Please ensure that the commencement date on your Listing Agreement
    matches the contract start date on MLS.`,
  },
  {
    type: "note",
    category: [`letterOpinion`],
    text: `Since the transaction staff will be creating an invoice for the client, 
    please be sure to include contact information (ie. Email Address) so that the 
    invoice can be sent out. Alternatively, the transaction staff can provide you
    the invoice for you to send to the client.`,
  },
  {
    type: "note",
    category: [`lease`],
    text: `<strong>Closing Procedure:</strong> Please email
    <a href="mailto:onpayouts@exprealty.net">onpayouts@exprealty.net</a>
    once the tenants have taken possession. This will trigger the closing
    process so that commissions/excess funds can be disbursed.`,
  },
  {
    type: "note",
    category: [`lease`],
    text: `FINTRAC documents are not required on leases. However, it is important
    to check the identification of your client(s).`,
  },
  {
    type: "note",
    category: [`lease`],
    text: `Ensure you have read and understand the Residential Tenancies Act (RTA),
    or you may put your client, the brokerage, and yourself at risk. Do not
    include any unenforceable clauses.`,
  },
  {
    type: "note",
    category: [`lease`],
    text: `Verify the unit is legal and has met fire, electrical and zoning
    requirements with the Municipality.`,
  },
  {
    type: "note",
    category: [`lease`],
    text: `The government mandated Ontario Standard Lease Agreement is to be filled
    out between the landlord and tenant, do not complete on their behalf. In
    addition, do not serve notices on behalf of the landlord. These should
    be completed and submitted by the landlord, a paralegal or a lawyer.`,
  },
  {
    type: "note",
    category: [`fsbo`],
    text: `In addition to your client, it is important to identify the Seller(s) in
    this type of transaction to verify they have authority to sell the
    property.`,
  },
  {
    type: "note",
    category: [`fsbo`],
    text: `Deposit should be held in eXp trust account or a lawyer's and NEVER 
    directly to the Seller.`,
  },
  {
    type: "note",
    category: [`fsbo`],
    text: `Ensure the deposit amount is enough to cover commission.`,
  },

  {
    type: "note",
    category: [`assignListing`, `assignPurchase`],
    text: `Agreements of Purchase and Sale are assignable by nature, unless
        otherwise specified. It's important to acquire the original purchase 
        agreement prior to listing to verify that the agreement is eligible for 
        assignment.`,
  },
  {
    type: "note",
    category: [`assignListing`, `assignPurchase`],
    text: `If it's a Pre-Con assignment, builders' consent is typically required,
    and so the builder consent clause should be included. In addition, it is always 
    recommended to have a lawyer review conditions in the agreement as these
    can be complex transactions.`,
  },
  {
    type: "note",
    category: [`assignListing`, `assignPurchase`],
    text: `Have your clients obtain a lawyer that is both experienced and
    comfortable doing assignment agreements.`,
  },
  {
    type: "note",
    category: [`assignListing`],
    text: `It is important to check the original purchase contract or speak with
    the builder to find out if the property can be advertised (both MLS and public 
    websites).`,
  },
  {
    type: "note",
    category: [`assignPurchase`],
    text: `Thoroughly inspect the original purchase contract to understand the 
    specifics of the assignment for your client.`,
  },
  {
    type: "note",
    category: [`purchase`, `assignPurchase`, `listing`],
    text: `As per TRESA, all representation agreements should be accompanied by a
    Schedule A, outlining the services to be provided to the client.`,
  },
  {
    type: "note",
    category: [`purchase`, `assignPurchase`],
    text: `<strong>FINTRAC Receipt of Funds:</strong> Required when deposit is
    going to a brokerage trust account. Typical situations when ROF is not
    required include when the deposit goes directly to a builder or lawyer's
    trust account.`,
  },
  {
    type: "note",
    category: [`purchase`, `assignPurchase`],
    text: `Ensure your BRA is signed on or before the commencement date of
    the agreement and before an offer is made.`,
  },
  {
    type: "note",
    category: [`purchase`, `assignPurchase`],
    text: `It is important to identify your Buyer clients before proceeding with 
    signing an agreement, to ensure the names on the agreement are correct and all 
    parties signing have the authority to do so.`,
  },
  {
    type: "note",
    category: [`purchase`, `assignPurchase`, `listing`],
    text: `“Time is of the essence” when it comes to agreements. Make sure that 
    agreements and related deal documents are signed within their designated time 
    frames to best protect your clients.`,
  },
  {
    type: "note",
    category: [`disclosure`],
    text: `<strong>Registrant's Disclosure:</strong> As per RECO, a registrant's
    disclosure form must be signed by the party being disclosed to BEFORE
    an offer is made/accepted. Manager signature can happen after the deal is done. 
    <br/>If the property interest is with the Buyer/Tenant, complete FORM 160.
    <br/>If the property interest is with the Seller/Landlord, complete FORM 161.`,
  },
  {
    type: "note",
    category: [`directions`],
    text: `<strong>Form 244 - Seller's Direction: </strong>Any directions
    concerning the listing and/or specifically the delaying of an offer
    presentation date should be clearly outlined in the Seller's Direction
    Form. If at any point the details of the directions change, a new form
    should be completed, communicated to all interested parties and uploaded to
    your listing.`,
  },
  {
    type: "note",
    category: [`listing`],
    text: `<strong>Estate or Power of Attorney Listings:</strong> Please ensure the
    “Seller” name on the agreement reflects the individual(s) listed on
    title. If it is an estate, then put the Seller as: “The Estate of
    (deceased name).” If it is a Power of Attorney, "(Name on Title) by (attorney 
      name) under Power of Attorney." The supporting documents are required to prove 
      those
    signing the documents have the authority to do so. Depending on the
    situation, documents such as the Will/Certificate of Appointment or
    Power of Attorney documents are required to prove signing authority.`,
  },
  {
    type: "note",
    category: [`listing`],
    text: `<strong>Corporation Listings: </strong>If a corporation is listing a
    property, it is important to obtain supporting documents, such as the
    Articles of Incorporation, to ensure the parties signing the agreement
    have the authority to do so on behalf of the Corporation.`,
  },
  {
    type: "note",
    category: [`listing`],
    text: `It is important to identify your Seller clients before proceeding with
    signing an agreement to verify the names on the agreement are correct
    and all parties signing have the authority to do so.`,
  },
  {
    type: "note",
    category: [`listing`],
    text: `It is the responsibility of the listing agent to make sure that all 
    details on the listing are correct. Please verify all listing details with your
    client, by carrying out the activities yourself (example: measurements)
    and other professional tools (example: GeoWarehouse).`,
  },
  {
    type: "note",
    category: [`listing`],
    text: `If your listing sells in a multiple offer scenario, please upload all
    registered offers or Form 801s to your deal in SkySlope.`,
  },
  {
    type: "note",
    category: [`referral`],
    text: `Referrals or other payments must be paid through the brokerage.`,
  },
  {
    type: "note",
    category: [`referral`],
    text: `Please complete the “Results of the Referral” section at the bottom of
    Form 641 (if applicable).`,
  },
  {
    type: "note",
    category: [`referral`],
    text: `We are NOT legally permitted to pay referrals to those who are not
    registered salespeople or brokers.`,
  },

  {
    type: "note",
    category: [`referral`],
    text: `Clients should sign the referral form to confirm disclosure requirements have been
    met as per our Code of Ethics. If clients refuse to sign, their consent
    may not be required but proof of written disclosure must occur. Consent is required by RECO if it involves a
    change to a commission agreement or a conflict of interest.`,
  },
  {
    type: "note",
    category: [`srp`],
    text: `A person would be considered a consumer until they either choose to be a
    Self-Represented Party (SRP) or a Client.`,
  },
  {
    type: "note",
    category: [`srp`],
    text: `It is important to take the necessary steps to identify an SRP not only
    for the transaction itself but also for the best interests of your
    client. As per FINTRAC requirements, we are obligated to take best
    measures to identify and complete the necessary paperwork for all
    parties to the transaction.`,
  },
  {
    type: "note",
    category: [`srp`],
    text: `You cannot prepare an offer on behalf of an SRP. However, in the case
    where you have a listing, you can prepare an offer on behalf of your
    client (the Seller) and send it to the SRP. This is also known as a
    reverse offer.`,
  },
  {
    type: "note",
    category: [`mere`],
    text: `In a mere posting situation, as per TRESA, the Listing Brokerage still provides 
    representation to the Seller client.`,
  },
  {
    type: "note",
    category: [`exclusiveListing`],
    text: `<strong>Exclusive Listings:</strong> In accordance with the REALTOR® Cooperation Policy, Members must, 
    within three (3) calendar days of any Public Marketing, place the Listing on 
    the MLS® System for cooperation with other REALTORS®. The following Listings 
    are exempt from the requirements above: rental, commercial, agricultural, 
    new construction in developments with multiple units, and assignments of pre-con 
    properties where title has not been transferred. See the following 
    link for more information: 
    <a href="https://www.CREA.ca/REALTORCooperation" target="_blank" rel="noopener noreferrer">CREA.ca/REALTORCooperation</a>`,
  },
];

export default importantNotes;
